import { styled } from "styled-components";
import { EmailInput, PasswordInput } from "../input/Inputs";

interface SignInFormProps {
    formData: {
      email: string;
      password: string;
    };
    errors: Record<string, string>;
    onFieldChange: (field: string, value: string) => void;
    onForgotPassword: () => void;
  }
  
  export const SignInForm: React.FC<SignInFormProps> = ({
    formData,
    errors,
    onFieldChange,
    onForgotPassword,
  }) => (
    <>
      <EmailInput
        label="Email"
        value={formData.email}
        onChange={(e) => onFieldChange('email', e.target.value)}
        error={errors.email}
        placeholder="your@email.com"
        name="email"
      />
      
      <PasswordInput
        label="Password"
        name="password"
        value={formData.password}
        onChange={(e) => onFieldChange('password', e.target.value)}
        error={errors.password}
        placeholder="••••••••"
      />
  
      {errors.password && (
        <ForgotPassword onClick={onForgotPassword}>
          Forgot your password?
        </ForgotPassword>
      )}
    </>
  );

  const ForgotPassword = styled.a`
  color: ${({ theme }) => theme.colors.fontGray[300]} !important;
  cursor: pointer;
  text-decoration: underline !important;
  font-size: 18px;
  font-weight: 700;
  line-height: normal;
  text-align: center;
  margin: 48px 0;
  
  &:hover {
    opacity: 0.8;
  }
`;